export const BATCH_JOBS_DASHBOARD = {
  // Common / Navigation
  RETURN_TO_DASHBOARD: { key: 'RETURN_TO_DASHBOARD', value: 'Return to Dashboard' },
  BACK: { key: 'BACK', value: 'Back' },
  NEXT: { key: 'NEXT', value: 'Next' },
  DOWNLOAD: { key: 'DOWNLOAD', value: 'Download' },
  INITIATE_CALL: { key: 'INITIATE_CALL', value: 'Initiate Call' },
  SEND: { key: 'SEND', value: 'Send' },
  CREATING_BATCH: { key: 'CREATING_BATCH', value: 'Creating Batch' },
  CREATE_BATCH_BUTTON: { key: 'CREATE_BATCH_BUTTON', value: 'Create Batch' },
  SAVE_N_PROCEED_BUTTON: { key: 'SAVE_N_PROCEED_BUTTON', value: 'Save & Proceed' },
  PROCEED_TO_PROOFING_BUTTON: { key: 'PROCEED_TO_PROOFING_BUTTON', value: 'Proceed to Proofing' },
  NEXT_BUTTON: { key: 'NEXT_BUTTON', value: 'Next' },
  SUBMIT_JOB_BUTTON: { key: 'SUBMIT_JOB_BUTTON', value: 'Submit Job' },

  // CreateBatch.js
  CREATE_NEW_BATCH_TITLE: { key: 'CREATE_NEW_BATCH_TITLE', value: 'Create New Batch' },
  CREATE_NEW_BATCH_SUBTITLE: {
    key: 'CREATE_NEW_BATCH_SUBTITLE',
    value: 'Follow the steps to set up your batch job',
  },
  SUCCESS_SCHEDULE_JOB: {
    key: 'SUCCESS_SCHEDULE_JOB',
    value: 'You have successfully scheduled the Job.',
  },
  FAILED_SCHEDULE_JOB: {
    key: 'FAILED_SCHEDULE_JOB',
    value: 'Failed to submit the job. Please try again later.',
  },
  SUCCESS_CREATE_JOB: {
    key: 'SUCCESS_CREATE_JOB',
    value: 'You have successfully created the Job.',
  },
  DATA_INVALID: { key: 'DATA_INVALID', value: 'Data provided is not valid' },
  PROCEED_BUTTON: { key: 'PROCEED_BUTTON', value: 'Proceed' },

  // Step 1
  BATCH_INFORMATION_TITLE: { key: 'BATCH_INFORMATION_TITLE', value: 'Batch Information' },
  BATCH_INFORMATION_SUBTITLE: {
    key: 'BATCH_INFORMATION_SUBTITLE',
    value: 'Configure your batch settings',
  },
  JOB_NAME_LABEL: { key: 'JOB_NAME_LABEL', value: 'Job Name' },
  JOB_NAME_PLACEHOLDER: {
    key: 'JOB_NAME_PLACEHOLDER',
    value: 'Enter a descriptive name for your batch job',
  },
  JOB_TYPE_LABEL: { key: 'JOB_TYPE_LABEL', value: 'Job Type' },
  STANDARD_TYPE: { key: 'STANDARD_TYPE', value: 'QUICK' },
  FORM_TYPE: { key: 'FORM_TYPE', value: 'FORM' },
  ADVANCED_TYPE: { key: 'ADVANCED_TYPE', value: 'STANDARD' },
  STANDARD_DESC: { key: 'STANDARD_DESC', value: 'Quick batch processing with default settings' },
  FORM_DESC: { key: 'FORM_DESC', value: 'Form-based batch with custom fields' },
  ADVANCED_DESC: { key: 'ADVANCED_DESC', value: 'Full control with scheduling options' },
  DELIVERY_CHANNEL_LABEL: { key: 'DELIVERY_CHANNEL_LABEL', value: 'Delivery Channel' },
  FORM_USER_ROLE_REQUIRED_ERROR: { key: 'FORM_USER_ROLE_REQUIRED_ERROR', value: 'Users with the FORM USER role can only access forms.' },

  // Step 2
  LANGUAGE_AND_TEMPLATE_TITLE: { key: 'LANGUAGE_AND_TEMPLATE_TITLE', value: 'Language & Template' },
  LANGUAGE_AND_TEMPLATE_SUBTITLE: {
    key: 'LANGUAGE_AND_TEMPLATE_SUBTITLE',
    value: 'Select language and choose your template',
  },
  SEARCH_SELECT_TEMPLATE_LABEL: {
    key: 'SEARCH_SELECT_TEMPLATE_LABEL',
    value: 'Search & Select Template',
  },
  SEARCH_TEMPLATES_PLACEHOLDER: {
    key: 'SEARCH_TEMPLATES_PLACEHOLDER',
    value: 'Search templates by name...',
  },
  TEMPLATES_AVAILABLE: { key: 'TEMPLATES_AVAILABLE', value: 'templates available' },
  TEMPLATE_SELECTED: { key: 'TEMPLATE_SELECTED', value: 'Template selected' },
  MISSING_TEMPLATE_WARNING: { key: 'MISSING_TEMPLATE_WARNING', value: 'Multi channel selected, but template has only {{type}}' },
  LOADING_MORE: { key: 'LOADING_MORE', value: 'Loading more...' },
  SELECT_LANGUAGE_LABEL: { key: 'SELECT_LANGUAGE_LABEL', value: 'Select Language' },
  SELECT_LANGUAGE_PLACEHOLDER: { key: 'SELECT_LANGUAGE_PLACEHOLDER', value: 'Select language' },
  SELECTED_BADGE: { key: 'SELECTED_BADGE', value: 'Selected' },
  CHOOSE_TEMPLATE_TITLE: { key: 'CHOOSE_TEMPLATE_TITLE', value: 'Choose Your Template' },
  CHOOSE_TEMPLATE_SUBTITLE: {
    key: 'CHOOSE_TEMPLATE_SUBTITLE',
    value: 'Select a template for your batch job',
  },
  FAILED_FETCH_TEMPLATES: { key: 'FAILED_FETCH_TEMPLATES', value: 'Failed to fetch templates' },
  FAILED_FETCH_TEMPLATES_LATER: {
    key: 'FAILED_FETCH_TEMPLATES_LATER',
    value: 'Failed to fetch templates. Please try again later',
  },
  CREATED_ON: { key: 'CREATED_ON', value: 'Created' },

  // Step 3 Data Upload
  UPLOAD_DATA_FILE_TITLE: { key: 'UPLOAD_DATA_FILE_TITLE', value: 'Upload Data File' },
  UPLOAD_DATA_FILE_SUBTITLE: {
    key: 'UPLOAD_DATA_FILE_SUBTITLE',
    value: 'Select file format and upload your data',
  },
  NEED_TEMPLATE: { key: 'NEED_TEMPLATE', value: 'Need a template?' },
  DOWNLOAD_SAMPLE_DESCRIPTION: {
    key: 'DOWNLOAD_SAMPLE_DESCRIPTION',
    value: 'Download a sample file to understand the required data format',
  },
  DOWNLOAD_SAMPLE_BUTTON: { key: 'DOWNLOAD_SAMPLE_BUTTON', value: 'Download Sample' },
  UPLOAD_AREA_TITLE: { key: 'UPLOAD_AREA_TITLE', value: 'Upload your data file' },
  UPLOAD_AREA_DESCRIPTION: { key: 'UPLOAD_AREA_DESCRIPTION', value: 'Drag and drop your file here or click to browse' },
  SELECT_FILE_BUTTON: { key: 'SELECT_FILE_BUTTON', value: 'SELECT A FILE' },
  FILE_UPLOADED_SUCCESS: { key: 'FILE_UPLOADED_SUCCESS', value: 'File uploaded successfully!' },
  CHANGE_FILE: { key: 'CHANGE_FILE', value: 'Change File' },
  ERROR_FETCH_TEMPLATE_DATA: {
    key: 'ERROR_FETCH_TEMPLATE_DATA',
    value: 'Error while fetching template data. Please try again later',
  },

  // Step 3 Form Filling
  FILL_DYNAMIC_VALUES_TITLE: { key: 'FILL_DYNAMIC_VALUES_TITLE', value: 'Fill Dynamic Values' },
  ENTER_INFO_FOR: { key: 'ENTER_INFO_FOR', value: 'Enter information for your' },
  TO_EMAIL_ADDRESS: { key: 'TO_EMAIL_ADDRESS', value: 'To Email Address' },
  CC_EMAIL_ADDRESS: { key: 'CC_EMAIL_ADDRESS', value: 'CC Email Address (Optional)' },
  TO_EMAIL_ADDRESS_DESCRIPTION_N: {
    key: 'TO_EMAIL_ADDRESS_DESCRIPTION_N',
    value: 'Enter recipient email address'
  },
  CC_EMAIL_ADDRESS_DESCRIPTION_N: {
    key: 'CC_EMAIL_ADDRESS_DESCRIPTION_N',
    value: 'Add CC email addresses (press Enter to add multiple)'
  },
  TO_PHONE_NUMBER_DESCRIPTION: {
    key: 'TO_PHONE_NUMBER_DESCRIPTION',
    value: 'Enter a phone number with country code'
  },
  TO_PHONE_NUMBER: { key: 'TO_PHONE_NUMBER', value: 'To Phone Number' },
  TO_EMAIL_PLACEHOLDER: { key: 'TO_EMAIL_PLACEHOLDER', value: 'Enter recipient email address' },
  CC_EMAIL_PLACEHOLDER_N: { key: 'CC_EMAIL_PLACEHOLDER_N', value: 'Type an email address and press Enter' },
  PHONE_NUMBER_PLACEHOLDER: { key: 'PHONE_NUMBER_PLACEHOLDER', value: 'Enter phone number' },
  NO_VARIABLES: { key: 'NO_VARIABLES', value: "This template doesn't contain any variables." },
  DOC_DOWNLOAD_SUCCESS: { key: 'DOC_DOWNLOAD_SUCCESS', value: 'Document downloaded successfully!' },
  EMAIL_REQ_SUCCESS: { key: 'EMAIL_REQ_SUCCESS', value: 'Email request submitted successfully.' },
  SMS_SENT_SUCCESS: { key: 'SMS_SENT_SUCCESS', value: 'Message sent successfully.' },
  CALL_INITIATED_SUCCESS: {
    key: 'CALL_INITIATED_SUCCESS',
    value: 'Phone call has been initiated successfully.',
  },
  ERR_UNEXPECTED: {
    key: 'ERR_UNEXPECTED',
    value: 'Unable to process your request due to unexpected failure',
  },
  ERR_VAR_VALIDATION: {
    key: 'ERR_VAR_VALIDATION',
    value: 'Unable to process your request due to variable validation failure',
  },
  ERR_TEMPLATE_NOT_FOUND: {
    key: 'ERR_TEMPLATE_NOT_FOUND',
    value: 'The selected template was not found. Please try again.',
  },
  ERR_COMM_ID_NOT_EXIST: {
    key: 'ERR_COMM_ID_NOT_EXIST',
    value: "Communication Id doesn't exist for the channel/language selected",
  },

  // Step 4 Proof Batch & ProofViewer
  PROOFS_HEADER: { key: 'PROOFS_HEADER', value: 'Proofs' },
  SELECT_PROOF_HEADER: { key: 'SELECT_PROOF_HEADER', value: 'Select Proof' },
  VIEW_MODE_HEADER: { key: 'VIEW_MODE_HEADER', value: 'View Mode' },
  DESKTOP_MODE: { key: 'DESKTOP_MODE', value: 'DESKTOP' },
  MOBILE_MODE: { key: 'MOBILE_MODE', value: 'MOBILE' },
  QUICK_ACTIONS_HEADER: { key: 'QUICK_ACTIONS_HEADER', value: 'Quick Actions' },
  FIRST_5_PROOFS: { key: 'FIRST_5_PROOFS', value: 'First 5 Proofs' },
  LAST_5_PROOFS: { key: 'LAST_5_PROOFS', value: 'Last 5 Proofs' },
  SEARCH_PROOFS: { key: 'SEARCH_PROOFS', value: 'Search Proofs' },
  SEARCH_PROOFS_PLACEHOLDER: {
    key: 'SEARCH_PROOFS_PLACEHOLDER',
    value: 'Search by name, email, phone, city, postcode, ref, or customer ID...',
  },
  NO_PROOFS_FOUND: { key: 'NO_PROOFS_FOUND', value: 'No proofs found' },
  TRY_DIFFERENT_SEARCH: { key: 'TRY_DIFFERENT_SEARCH', value: 'Try a different search term' },
  PREVIEW_LABEL: { key: 'PREVIEW_LABEL', value: 'Preview' },
  DEAR_LABEL: { key: 'DEAR_LABEL', value: 'Dear' },
  HOMECARE_NUMBER: { key: 'HOMECARE_NUMBER', value: 'Your HomeCare Number:' },
  FROM_LABEL: { key: 'FROM_LABEL', value: 'From:' },
  TO_LABEL: { key: 'TO_LABEL', value: 'To:' },
  SUBJECT_LABEL: { key: 'SUBJECT_LABEL', value: 'Subject:' },
  PLEASE_CONTACT: {
    key: 'PLEASE_CONTACT',
    value: 'Please contact us at your earliest convenience.',
  },
  BEST_REGARDS: { key: 'BEST_REGARDS', value: 'Best regards,' },
  CUSTOMER_ID_LABEL: { key: 'CUSTOMER_ID_LABEL', value: 'Customer ID:' },
  SMS_PREVIEW_TO: { key: 'SMS_PREVIEW_TO', value: 'SMS Preview - To:' },
  SENT_VIA_SMS_GATEWAY: { key: 'SENT_VIA_SMS_GATEWAY', value: 'Sent via SMS Gateway' },
  APPROVE_PROOFS_TITLE: { key: 'APPROVE_PROOFS_TITLE', value: 'Approve Proofs' },
  APPROVED_PROOFS_TITLE: { key: 'APPROVED_PROOFS_TITLE', value: 'Proofs Approved' },
  APPROVE_PROOFS_DESC: {
    key: 'APPROVE_PROOFS_DESC',
    value:
      'Review all {{channel}} proofs above. Once approved, you can proceed to schedule your campaign.',
  },
  APPROVED_PROOFS_DESC: {
    key: 'APPROVED_PROOFS_DESC',
    value:
      'All {{channel}} proofs have been reviewed and approved.',
  },
  PROOFS_APPROVED_BUTTON: { key: 'PROOFS_APPROVED_BUTTON', value: '✓ Proofs Approved' },
  APPROVE_PROOFS_BUTTON: { key: 'APPROVE_PROOFS_BUTTON', value: 'Approve Proofs' },

  // Step 5 Scheduling
  SCHEDULE_CAMPAIGN_TITLE: { key: 'SCHEDULE_CAMPAIGN_TITLE', value: 'Schedule Campaign' },
  SCHEDULE_CAMPAIGN_SUBTITLE: {
    key: 'SCHEDULE_CAMPAIGN_SUBTITLE',
    value: 'Choose when to send your batch',
  },
  ENABLE_SCHEDULING: { key: 'ENABLE_SCHEDULING', value: 'Enable Scheduling' },
  SCHEDULE_DESC: { key: 'SCHEDULE_DESC', value: 'Send at a specific date and time' },
  SEND_IMMEDIATELY: { key: 'SEND_IMMEDIATELY', value: 'Send Immediately' },
  SEND_MANUALLY: { key: 'SEND_MANUALLY', value: 'Send Manually' },
  SEND_IMMEDIATELY_DESC: {
    key: 'SEND_IMMEDIATELY_DESC',
    value: 'Your batch will be processed and sent right away',
  },
  SEND_MANUALLY_DESC: {
    key: 'SEND_MANUALLY_DESC',
    value: 'Your batch will be processed. You can send it whenever you’re ready',
  },
  SELECT_DATE: { key: 'SELECT_DATE', value: 'Select Date' },
  SELECT_TIME: { key: 'SELECT_TIME', value: 'Select Time' },
  ENABLE_APPROVAL: { key: 'ENABLE_APPROVAL', value: 'Enable Approval' },
  APPROVAL_DESC: { key: 'APPROVAL_DESC', value: 'Require approval before job execution' },
  APPROVAL_LEVEL: { key: 'APPROVAL_LEVEL', value: 'Approval Level' },
  SPECIFIC_USER: { key: 'SPECIFIC_USER', value: 'Specific User' },
  SELECT_APPROVAL_LEVEL: { key: 'SELECT_APPROVAL_LEVEL', value: 'Select Approval Level' },
  APPROVAL_LEVEL_REQUIRED_DESC: {
    key: 'APPROVAL_LEVEL_REQUIRED_DESC',
    value: 'Level {{level}} approval will be required before this job executes',
  },
  SELECT_APPROVER: { key: 'SELECT_APPROVER', value: 'Select Approver' },
  SEARCH_USER_PLACEHOLDER: { key: 'SEARCH_USER_PLACEHOLDER', value: 'Search for a user...' },
  LEVEL_LABEL: { key: 'LEVEL_LABEL', value: 'Level {{level}}' },

  // Steps
  STEP_BATCH_INFO_TITLE: { key: 'STEP_BATCH_INFO_TITLE', value: 'Batch Information' },
  STEP_BATCH_INFO_DESC: { key: 'STEP_BATCH_INFO_DESC', value: 'Configure your batch settings' },
  STEP_TEMPLATE_SEL_TITLE: { key: 'STEP_TEMPLATE_SEL_TITLE', value: 'Template Selection' },
  STEP_TEMPLATE_SEL_DESC: { key: 'STEP_TEMPLATE_SEL_DESC', value: 'Choose your template' },
  STEP_DATA_UPLOAD_TITLE: { key: 'STEP_DATA_UPLOAD_TITLE', value: 'Data Upload' },
  STEP_DATA_UPLOAD_DESC: { key: 'STEP_DATA_UPLOAD_DESC', value: 'Upload your data file' },
  STEP_PROOF_BATCH_TITLE: { key: 'STEP_PROOF_BATCH_TITLE', value: 'Proof Batch' },
  STEP_PROOF_BATCH_DESC: { key: 'STEP_PROOF_BATCH_DESC', value: 'Review and validate' },
  STEP_SCHEDULE_TITLE: { key: 'STEP_SCHEDULE_TITLE', value: 'Schedule Campaign' },
  STEP_SCHEDULE_DESC: { key: 'STEP_SCHEDULE_DESC', value: 'Set date and time' },
  STEP_LANG_TEMPLATE_TITLE: { key: 'STEP_LANG_TEMPLATE_TITLE', value: 'Language & Template' },
  STEP_LANG_TEMPLATE_DESC: {
    key: 'STEP_LANG_TEMPLATE_DESC',
    value: 'Select language and template',
  },
  STEP_FILL_FORM_TITLE: { key: 'STEP_FILL_FORM_TITLE', value: 'Fill Form' },
  STEP_FILL_FORM_DESC: { key: 'STEP_FILL_FORM_DESC', value: 'Enter dynamic values' },

  // Messages
  MSG_DOC_DOWNLOADING: {
    key: 'MSG_DOC_DOWNLOADING',
    value: 'Your document is getting downloaded...',
  },
  MSG_EMAIL_SENT: { key: 'MSG_EMAIL_SENT', value: 'Your email has been sent successfully' },
  MSG_SMS_SENT: { key: 'MSG_SMS_SENT', value: 'Your sms is sent successfully' },
  MSG_JOB_SUBMITTED_APPROVAL: {
    key: 'MSG_JOB_SUBMITTED_APPROVAL',
    value:
      'Your Job is successfully submitted. But will run only on approval from {{approverName}}',
  },
  MSG_JOB_SCHEDULED_DATE: {
    key: 'MSG_JOB_SCHEDULED_DATE',
    value: 'You have successfully scheduled the Job. It will run on {{date}} at {{time}}',
  },
  MSG_JOB_SCHEDULED: {
    key: 'MSG_JOB_SCHEDULED',
    value: 'You have successfully scheduled the Job.',
  },
  LEVEL_APPROVER_NAME: { key: 'LEVEL_APPROVER_NAME', value: 'Level {{level}} Approver' },
  THE_APPROVER: { key: 'THE_APPROVER', value: 'the approver' },

  // Preview Table
  PREVIEW_TABLE_DESC: { key: 'PREVIEW_TABLE_DESC', value: 'Description' },
  PREVIEW_TABLE_AMOUNT: { key: 'PREVIEW_TABLE_AMOUNT', value: 'Amount' },
  PREVIEW_SERVICE_CHARGE: { key: 'PREVIEW_SERVICE_CHARGE', value: 'Service Charge' },
  PREVIEW_USAGE_FEES: { key: 'PREVIEW_USAGE_FEES', value: 'Usage Fees' },
  PREVIEW_TOTAL: { key: 'PREVIEW_TOTAL', value: 'Total' },

  // Roles
  ROLE_MANAGER: { key: 'ROLE_MANAGER', value: 'Manager' },
  ROLE_DIRECTOR: { key: 'ROLE_DIRECTOR', value: 'Director' },
  ROLE_TEAM_LEAD: { key: 'ROLE_TEAM_LEAD', value: 'Team Lead' },
  ROLE_SUPERVISOR: { key: 'ROLE_SUPERVISOR', value: 'Supervisor' },
  ROLE_SENIOR_MANAGER: { key: 'ROLE_SENIOR_MANAGER', value: 'Senior Manager' },

  // Channels
  CHANNEL_MULTI_CHANNEL: { key: 'CHANNEL_MULTI_CHANNEL', value: 'multi-channel' },
  CHANNEL_PRINT: { key: 'CHANNEL_PRINT', value: 'print' },
  CHANNEL_EMAIL: { key: 'CHANNEL_EMAIL', value: 'email' },
  CHANNEL_SMS: { key: 'CHANNEL_SMS', value: 'sms' },
  CHANNEL_CALL: { key: 'CHANNEL_CALL', value: 'call' },

  // File Formats
  FORMAT_EXCEL: { key: 'FORMAT_EXCEL', value: 'Excel' },
  FORMAT_JSON: { key: 'FORMAT_JSON', value: 'JSON' },
  FORMAT_XML: { key: 'FORMAT_XML', value: 'XML' },
  FORMAT_CSV: { key: 'FORMAT_CSV', value: 'CSV' },
  FORMAT_TXT_TAB: { key: 'FORMAT_TXT_TAB', value: 'TXT (Tab Delimited)' },
  FORMAT_TXT_PIPE: { key: 'FORMAT_TXT_PIPE', value: 'TXT (Pipe Delimited)' },
  SCHEDULE_DATE_TIME_REQUIRED: {
    key: 'schedule_date_time_required',
    value: 'Please select schedule date and time',
  },
  APPROVER_REQUIRED: {
    key: 'approver_required',
    value: 'Please select an approver',
  },
  LEVEL_REQUIRED: {
    key: 'level_required',
    value: 'Please select a level',
  },
  DATE_TIME_TO_SCHEDULE: { key: 'DATE_TIME_TO_SCHEDULE', value: 'Date & Time to Schedule the Job' },
  FAILED_TO_LOAD_PDF: { key: 'FAILED_TO_LOAD_PDF', value: 'Failed to load PDF' },
  SEARCH_KEY_VALUE_PLACEHOLDER: { key: 'SEARCH_KEY_VALUE_PLACEHOLDER', value: 'Search by name, email, etc. (key: value)' },
  SAVE_AND_PROCEED: { key: 'SAVE_AND_PROCEED', value: 'Save & Proceed' },
  PROCEED_TO_PROOFING: { key: 'PROCEED_TO_PROOFING', value: 'Proceed to Proofing' },
  SCHEDULE_THIS_JOB: { key: 'SCHEDULE_THIS_JOB', value: 'Schedule this Job' },
  SUBMIT_JOB: { key: 'SUBMIT_JOB', value: 'Submit Job' },
  FAILED_TO_SUBMIT_JOB: { key: 'FAILED_TO_SUBMIT_JOB', value: 'Failed to submit the job. Please try again later' },
  MSG_BATCH_SUBMIT_SUCCESS: { key: 'MSG_BATCH_SUBMIT_SUCCESS', value: 'Batch submitted successfully' },
  MSG_BATCH_SUBMIT_FAILED: { key: 'MSG_BATCH_SUBMIT_FAILED', value: 'Failed To Submit Batch For Processing' },
  META_KEYS_FETCH_FAILED: { key: 'META_KEYS_FETCH_FAILED', value: 'Failed to fetch search meta keys' },
  FAILED_TO_LOAD_EMAIL: { key: 'FAILED_TO_LOAD_EMAIL', value: 'Failed to load email preview' },
  PROOFS_FETCH_FAILED: { key: 'PROOFS_FETCH_FAILED', value: 'Failed to fetch proofs' },
  PROOF_APPROVAL_FAILED: { key: 'PROOF_APPROVAL_FAILED', value: 'Failed to approve proofs' },
  NO_RESULTS_FOR_SEARCH: { key: 'NO_RESULTS_FOR_SEARCH', value: 'No results found for your search' },
  NO_DOCUMENTS_FOUND: {key: 'NO_DOCUMENTS_FOUND', value: 'No documents found'},
  CLEAR_FILTERS_OR_MODIFY:{key: 'CLEAR_FILTERS_OR_MODIFY', value: 'Modify your search or clear the filters to see available documents.'},
  NO_EMAIL_PREVIEW:{key:'NO_EMAIL_PREVIEW', value: 'No email preview available'},
  CLEAR_FILTERS_OR_MODIFY_EMAIL:{key: 'CLEAR_FILTERS_OR_MODIFY_EMAIL', value: 'Modify your search or clear your search to view emails.'},
  RESULTS_LABEL: { key: 'RESULTS_LABEL', value: 'results' },
  SEARCH_RESULTS: { key: 'SEARCH_RESULTS', value: 'Search Results' },
};
